import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import styles from './MoreInfo.module.scss';
import { icons } from '../../../../assets';
import { useEffect } from 'react';
import {
  openMoreInfo,
  closeMoreInfo,
  selectMoreInfoPopup,
} from '../../../../redux/slicers/camera/renderPreviewPoppupSlicer';
import { ModalArea } from '../../../../common/ModalButtonArea';
import { Link } from 'react-router-dom';
import { TERMS_OF_USE_ROUTE } from '../../../../constants/routePathConstants';
import { Row, Col } from 'react-bootstrap';
const { FreeLicenseIcon, AttributionIcon, GreenTickIcon, RedCrossIcon, ColouredCrownIcon } = icons;

export const MoreInfo = () => {
  return (
    <>
      <FreeDownloadCard />
      <MoreInfoPopup />
    </>
  );
};

const FreeDownloadCard = () => {
  const dispatch = useDispatch();

  return (
    <div className={'mt-3 d-flex justify-content-between gap-3 px-2'}>
      <span className={styles.list}>
        <FreeLicenseIcon />
        <span className={styles.text}>Non Commercial License</span>
        <span className={styles.moreInfo} onClick={() => dispatch(openMoreInfo('free-license'))}>
          More info
        </span>
      </span>
      <span className={styles.list}>
        <AttributionIcon />
        <span className={styles.text}>Attribution is required</span>
        <span className={styles.moreInfo} onClick={() => dispatch(openMoreInfo('attribution'))}>
          More info
        </span>
      </span>
    </div>
  );
};

const MoreInfoPopup = () => {
  const modelOf = useSelector(selectMoreInfoPopup);
  const dispatch = useDispatch();
  const isFreeLicense = modelOf === 'free-license';

  useEffect(() => {
    return () => dispatch(closeMoreInfo());
  }, []);

  if (!modelOf) return null;

  const title = isFreeLicense ? 'License summary' : 'How to attribute?';
  const Content = isFreeLicense ? FreeLicenseContent : AttributionContent;

  return (
    <ModalArea
      showModal={Boolean(modelOf)}
      setShowModal={() => dispatch(closeMoreInfo())}
      title={title}
      size="md"
      centered={true}
      className={styles.smallModalWidth}
      animation
      body={
        <>
          <Content />
        </>
      }
    />
  );
};

const FreeLicenseContent = () => {
  return (
    <>
      <Row className="mt-3">
        <Col md={6} className={`${styles.leftContent} pt-2`}>
          <div className="d-flex justify-content-center align-items-center mb-2">
            <p className={`${styles.head} m-0`}>Non Commercial License</p>
          </div>
          <ul className={styles.points}>
            <li>
              <GreenTickIcon /> <span className={styles.content}>Personal use only.</span>
            </li>
            <li>
              <GreenTickIcon /> <span className={styles.content}>Attribution mandatory.</span>
            </li>
            <li>
              <RedCrossIcon />{' '}
              <span className={styles.content}>Download & Print outs not allowed.</span>
            </li>
          </ul>
        </Col>
        <Col md={6} className="pt-2">
          <div className="d-flex justify-content-center align-items-center mb-2">
            <ColouredCrownIcon />
            <p className={`${styles.head} m-0 mx-3`}>Premium License</p>
          </div>
          <ul className={styles.points}>
            <li>
              <GreenTickIcon /> <span className={styles.content}>Commercial use allowed.</span>
            </li>
            <li>
              <RedCrossIcon /> <span className={styles.content}>Attributes not required.</span>
            </li>
            <li>
              <GreenTickIcon />{' '}
              <span className={styles.content}>Unlimited Downloads & Print outs.</span>
            </li>
          </ul>
        </Col>
      </Row>
      <div className="d-flex justify-content-center align-items-center my-3 mx-0 pt-2 pb-2">
        <RedCrossIcon />{' '}
        <span className={styles.content}>
          Modification and creating derivative works is strictly prohibited.
        </span>
      </div>
      <Row>
        <p className={cx(styles.smallText, 'mb-0')}>
          This text is summary for information purposes only. It does not constitute any contractual
          abligations . For more information please read our{' '}
          <Link to={TERMS_OF_USE_ROUTE} target="_blank">
            Terms of use
          </Link>{' '}
          before using the content.
        </p>
      </Row>
    </>
  );
};

const AttributionContent = () => {
  return (
    <>
      <Row className='pt-3'>
        <ul className={styles.points} style={{ padding: 12 }}>
          <li className="d-block px-0 pt-0">
            <span className={styles.head}>Web : </span>
            <span className={styles.attributeContent}>
              Paste imagine.io website link, close to where you’re using the image or at the footer
              of your website, blog or newsletter, or in the credits section.
            </span>
          </li>
          <li className="d-block px-0 pt-0">
            <span className={styles.head}>Printed items : </span>
            <span className={styles.attributeContent}>
              Insert the attribution line close to where you’re using the image. <br /> Example:
              This image has been designed using imagine.io.
            </span>
          </li>
          <li className="d-block p-0">
            <span className={styles.head}>Social Media : </span>
            <span className={styles.attributeContent}>Give credits in caption or hashtag imagine.io.</span>
          </li>
        </ul>
      </Row>
      <Row className="mt-3">
        <p className={cx(styles.attributeBelowContent, 'mb-0')}>
          Creating content takes a lot of time and effort, which is why we ask you to provide a link
          to attribute the source.
        </p>
      </Row>
    </>
  );
};
